export const meta = {
	description: 'Browser-based cloud IDE with AI agents and instant previews. Code, build, and deploy from anywhere.',
	title: 'Codemaxxing — Cloud IDE',
	applicationName: 'Codemaxxing',
	productName: 'Codemaxxing',
	shortName: 'Codemaxxing',
	appSiteUrl: 'https://codemaxxing.app',
	landingSiteUrl: 'https://codemaxxing.ai',
	supportEmail: 'support@codemaxxing.ai',
} as const;
